export default {
      id: "common__chevron_up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__chevron_up",
      toString: function () {
        return this.url;
      }
    }